<template>
  <div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <!-- 底部导航 -->

    <van-tabbar v-model="active" @change="onChange" class="customTabbar">
      <van-tabbar-item>
        <img src='../../assets/qRCode/tj1.png' alt v-if="active == 0" />
        <img src='../../assets/qRCode/tj0.png' alt v-else />
        <span>汇总</span>
      </van-tabbar-item>
      <van-tabbar-item>
           <img src='../../assets/qRCode/wd1.png' alt v-if="active == 1" />
        <img src='../../assets/qRCode/wd0.png' alt v-else />
        <span>我的</span>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      vde: ""
    }
  },
  created() {
    this.vde = this.$route.query.vde ? this.$route.query.vde : ""
    // 获取到active的话，就能保证每次回退页面时，active的正确
    if (sessionStorage.getItem("activeNum")) {
      this.active = parseInt(sessionStorage.getItem("activeNum"))
    }else{
      this.active = 0
    }
  },
  methods: {
    onChange(e) {
      sessionStorage.setItem("activeNum", e.toString())
      if (e == 0) {
        this.$router.push({ path: "/parkingEntry?vde=" + this.vde })
      } else if (e == 1) {
        this.$router.push({ path: "/parkingEntry/home?vde=" + this.vde })
      }
    }
  }
}
</script>

<style lang='scss'>
.customTabbar{
  z-index: 10;
    .van-tabbar-item__text{
        text-align: center;
    }
    img{
        width: 19px;
        height: 20px;
        display: block;
        margin-left: 3px;
    }
    span{
        margin-top: 2px;
        display: block;

        font-size: 11px;
        // color: #208FFF;
        letter-spacing: 0;
        text-align: right;
        font-weight: 500;
    }
}
</style>
